import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 7.2C3 6.08 3 5.52 3.218 5.092C3.40974 4.71569 3.71569 4.40974 4.092 4.218C4.52 4 5.08 4 6.2 4H8.6C9.48 4 9.92 4 10.324 4.115C10.6818 4.21717 11.0176 4.38502 11.314 4.61C11.648 4.864 11.912 5.216 12.44 5.92L14 8H3V7.2Z",
		fill: "currentColor",
		fillOpacity: .4
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3 9.4C3 8.56 3 8.14 3.163 7.819C3.30685 7.53651 3.53651 7.30685 3.819 7.163C4.139 7 4.559 7 5.4 7H18.6C19.44 7 19.86 7 20.181 7.163C20.4631 7.30702 20.6924 7.53666 20.836 7.819C21 8.139 21 8.559 21 9.4V17.6C21 18.44 21 18.86 20.837 19.181C20.693 19.4631 20.4633 19.6924 20.181 19.836C19.861 20 19.441 20 18.6 20H5.4C4.56 20 4.14 20 3.819 19.836C3.53666 19.6924 3.30702 19.4631 3.163 19.181C3 18.861 3 18.441 3 17.6V9.4Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
